import { z } from 'zod';

import {
  amountSchema,
  jalaliMonthSchema,
  jalaliYearSchema,
  nameSchema,
} from '@/shared/validation/common';

/** Mirrors `MonthlyChargeCreate` minus `building_id`, supplied by the route. */
export const monthlyChargeSchema = z.object({
  name: nameSchema(100, 'عنوان شارژ'),
  amount: amountSchema,
  year: jalaliYearSchema,
  month: jalaliMonthSchema,
});
export type MonthlyChargeForm = z.input<typeof monthlyChargeSchema>;

/**
 * Mirrors `UnitChargeCreate`. An omitted amount tells the backend to split the
 * monthly total equally across the building's units, which is the common case.
 */
export const unitChargeSchema = z.object({
  amount: amountSchema.nullable(),
});
export type UnitChargeForm = z.input<typeof unitChargeSchema>;

/** Manual payment recorded by a manager on a resident's behalf. */
export const manualPaymentSchema = z.object({
  amount: amountSchema,
  paid_type: z.enum(['cash', 'card', 'transfer'], { message: 'نوع پرداخت را انتخاب کنید' }),
});
export type ManualPaymentForm = z.input<typeof manualPaymentSchema>;
